// extracted by mini-css-extract-plugin
export default {"backgroundImage":"HomePage_backgroundImage__EkOPt","mainTitle":"HomePage_mainTitle__DN5Lb","boxes":"HomePage_boxes__lCZo0","shopInfo":"HomePage_shopInfo__V+r2O"};